"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The AdScoreAttributeFilter model module.
 * @module model/AdScoreAttributeFilter
 * @version 1.1.3-alpha.1
 */
class AdScoreAttributeFilter {
  /**
   * Constructs a new <code>AdScoreAttributeFilter</code>.
   * @alias module:model/AdScoreAttributeFilter
   */
  constructor() {
    AdScoreAttributeFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>AdScoreAttributeFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AdScoreAttributeFilter} obj Optional instance to populate.
   * @return {module:model/AdScoreAttributeFilter} The populated <code>AdScoreAttributeFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AdScoreAttributeFilter();
      if (data.hasOwnProperty('active')) {
        obj['active'] = _ApiClient.default.convertToType(data['active'], 'Boolean');
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>AdScoreAttributeFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AdScoreAttributeFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {Boolean} active
 */
AdScoreAttributeFilter.prototype['active'] = undefined;

/**
 * @member {String} q
 */
AdScoreAttributeFilter.prototype['q'] = undefined;
var _default = AdScoreAttributeFilter;
exports.default = _default;